/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';

/**
 * 
 * @export
 * @interface PublishPromptRevisionRequestContent
 */
export interface PublishPromptRevisionRequestContent {
    /**
     * 
     * @type {CallingIdentity}
     * @memberof PublishPromptRevisionRequestContent
     */
    callingIdentity: CallingIdentity;
}


/**
 * Check if a given object implements the PublishPromptRevisionRequestContent interface.
 */
export function instanceOfPublishPromptRevisionRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "callingIdentity" in value;

    return isInstance;
}

export function PublishPromptRevisionRequestContentFromJSON(json: any): PublishPromptRevisionRequestContent {
    return PublishPromptRevisionRequestContentFromJSONTyped(json, false);
}

export function PublishPromptRevisionRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublishPromptRevisionRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'callingIdentity': CallingIdentityFromJSON(json['callingIdentity']),
    };
}

export function PublishPromptRevisionRequestContentToJSON(value?: PublishPromptRevisionRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'callingIdentity': CallingIdentityToJSON(value.callingIdentity),
    };
}

